export default __webpack_public_path__ + "static/5-actions-8d5ae2db9e5c274dd736397c43f965a4.png";